import * as React from "react";

import { useMyBagPresentationModel } from "../providers";

export const MyBagIsNotAVirtualOrderPortal: React.FunctionComponent = (
  props
) => {
  const { presentationMyBagOrder } = useMyBagPresentationModel();
  if (presentationMyBagOrder?.isThisAVirtualOrder) {
    return null;
  }
  return <React.Fragment>{props.children || []}</React.Fragment>;
};
